export default __webpack_public_path__ + "static/media/Oswald-SemiBold.b4a2943e.ttf";